import { Select } from "antd";

type Props = {
  title: string;
  value: string;
  handleChange: (value: string) => void;
  options: Array<{ text: string; value: string }>;
};
const TeamListFilter = ({ title, value, handleChange, options }: Props) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", position: "relative" }}>
      <div style={{ position: "absolute", top: "-20px" }}>{title}:</div>
      <Select
        value={value}
        onChange={handleChange}
        popupMatchSelectWidth={false}
        style={{ width: 100 }}
        options={options}
      />
    </div>
  );
};

export default TeamListFilter;
